import React from 'react';
import { Badge } from 'shared-components/components';
import { CardTitle, CardBody, CardBodyGroup, CardText, BubbleTitle } from './styles';
import CONSTANTS from './constants';
import { Typography, useTheme } from '@mui/material';
const { SEVERITY, NOTES, NO_ALLERGIES } = CONSTANTS;

const AllergiesCard = ({ name, allergies }: { name: string; allergies: any }): JSX.Element => {
  const filteredAllergies = allergies.filter((allergy: any) => allergy.status === 'Active');
  const theme = useTheme();
  const isNoKnownAllergy = filteredAllergies?.some(
    (allergy: any): boolean =>
      allergy.name && ['no known drug allergies', 'no known allergies'].includes(allergy.name.toLowerCase()),
  );

  const getBadgeColor = () => {
    if (isNoKnownAllergy) {
      return theme.palette.warning.dark;
    }
    if (filteredAllergies?.length > 0) {
      return theme.palette.error.main;
    }
    return theme.palette.primary.main;
  };

  const badgeText = isNoKnownAllergy ? 'N' : filteredAllergies.length || '';

  return (
    <div data-testid="allergiesCard">
      <CardTitle>
        {name}{' '}
        {badgeText && (
          <Badge $bgColor={getBadgeColor()} data-testid="allergiesBadge">
            {badgeText}
          </Badge>
        )}
      </CardTitle>
      <CardBody>
        {filteredAllergies.length ? (
          filteredAllergies.map((allergy: any, index: number) => (
            <CardBodyGroup key={allergy.name}>
              <Typography variant="body2">
                {index + 1}. {allergy.name}
              </Typography>
              <CardText>
                {SEVERITY}: {allergy.severity}
              </CardText>
              <CardText>
                {NOTES}: {allergy.reaction}
              </CardText>
            </CardBodyGroup>
          ))
        ) : (
          <CardBodyGroup>{NO_ALLERGIES}</CardBodyGroup>
        )}
      </CardBody>
    </div>
  );
};

export default AllergiesCard;
